var $1da58e3a411b6760$exports = {};
$1da58e3a411b6760$exports = {
    "colorFormat": `Farveformat`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$1da58e3a411b6760$exports as default};
//# sourceMappingURL=da-DK.mjs.map
